import React, {useEffect, useMemo, useState} from "react";
import {hash} from '../../utils';

const Gallery = ({
  images,
  className = "",
  ImageCardComponent,
  onImageSearchClick,
  getThumbnailUrl = (image: { url: string; }) => image.url,
  imagesPerPage = 9,
  hasFetchedResults,
}: {
  images: any[];
  className?: string;
  ImageCardComponent: React.ComponentType<any>;
  onImageSearchClick: (url: string) => void;
  getThumbnailUrl?: (image: any) => string;
  imagesPerPage?: number;
  hasFetchedResults: boolean;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(images.length / imagesPerPage);

  const currentImages = useMemo(() => {
    const start = (currentPage - 1) * imagesPerPage;
    const end = start + imagesPerPage;
    return images.slice(start, end);
  }, [images, currentPage, imagesPerPage]);

  // Compute hash of images, for use in key props
  const galleryHash = useMemo(async () => {
    return hash(currentImages.map((img: any) => img.url).join(""));
  }, [currentImages]);

  useEffect(() => {
    setCurrentPage(1);
  }, [images]);

  return (
    <div className={`${className}`}>
      <h1 className="flex w-full justify-center align-middle text-2xl text-blue-200">
        {hasFetchedResults ? "Results" : "Example Images"}
      </h1>
      <div className="mt-3 flex w-full flex-col items-center justify-center rounded-lg border-[1px] border-solid border-gray-200 bg-slate-100 pb-6 align-middle">
        <div className="mt-7 grid w-full grid-cols-3 gap-x-0 gap-y-4">
          {currentImages.map((image: any) => (
            <div key={image.url} className="flex justify-center">
              <ImageCardComponent
                imageSrc={image.url}
                thumbnailSrc={getThumbnailUrl(image)}
                onSearchClick={() => onImageSearchClick(image.url)}
              />
            </div>
          ))}
        </div>
        <div className="mt-4 flex w-full justify-center">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={`${galleryHash}-${i}`}
              onClick={() => setCurrentPage(i + 1)}
              className={`mx-1 rounded px-4 py-2 ${
                currentPage === i + 1 ? "bg-blue-500 text-white" : "bg-gray-200"
              }`}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
